// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".page-layout {\n  padding: 0 10%; }\n  @media (max-width: 700px) {\n    .page-layout {\n      padding: 0 0; } }\n", ""]);
// Exports
module.exports = exports;
